var _path, _path2, _g, _g2, _g3, _g4, _path3, _path4, _g5, _path5, _path6, _path7, _path8, _g6, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g7, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeave1 = function SvgLeave1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650.3 154.252C648.079 150.519 645.745 146.827 643.3 143.178C610.862 95.1019 555.016 62.2159 500.08 47.3479C475.978 40.9317 451.217 37.3145 426.286 36.5679C263.018 31.0379 197.988 159.768 144.032 192.92C90.0761 226.072 7.00012 282.8 12.6001 401.8C18.2001 520.8 103.908 632.8 269.934 639.8C435.96 646.8 447.034 572.012 539.728 544.334C601.076 526.022 644.728 464.17 666.008 407.022C695.1 329.112 693.728 227.934 650.3 154.252Z",
    fill: "#1B5FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M650.3 154.252C648.079 150.519 645.745 146.827 643.3 143.178C610.862 95.1019 555.016 62.2159 500.08 47.3479C475.978 40.9317 451.217 37.3145 426.286 36.5679C263.018 31.0379 197.988 159.768 144.032 192.92C90.0761 226.072 7.00012 282.8 12.6001 401.8C18.2001 520.8 103.908 632.8 269.934 639.8C435.96 646.8 447.034 572.012 539.728 544.334C601.076 526.022 644.728 464.17 666.008 407.022C695.1 329.112 693.728 227.934 650.3 154.252Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.62 411.516H34.4121V422.254H326.62V411.516Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3 422.212H39.8857V562.058H321.3V422.212Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 579.6H344.4",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4499 561.988H41.6499V578.55H51.4499V561.988Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.444 561.988H308.644V578.55H318.444V561.988Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.338 328.062H241.738C243.27 328.062 244.786 328.364 246.201 328.95C247.616 329.536 248.901 330.395 249.984 331.478C251.067 332.561 251.926 333.846 252.512 335.261C253.098 336.676 253.4 338.193 253.4 339.724V411.6H165.662V339.738C165.66 338.204 165.961 336.685 166.547 335.268C167.133 333.85 167.993 332.562 169.078 331.478C170.162 330.393 171.45 329.533 172.868 328.947C174.285 328.361 175.804 328.06 177.338 328.062Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.882 409.234H96.8657V411.852H140.882V409.234Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3361 408.478H51.1561C50.2437 408.479 49.3658 408.13 48.7039 407.502C48.042 406.874 47.6468 406.015 47.6001 405.104C47.5705 404.727 47.6085 404.348 47.7121 403.984L58.8001 372.19C58.6181 371.686 58.4361 371.196 58.2681 370.692C57.9876 369.753 57.8139 368.786 57.7501 367.808C57.4468 367.962 57.2157 368.228 57.1061 368.55L45.0381 403.2C44.8403 403.882 44.7598 404.592 44.8001 405.3C44.8861 406.928 45.5931 408.461 46.7755 409.584C47.958 410.706 49.5258 411.333 51.1561 411.334H70.3361C70.7074 411.334 71.0635 411.187 71.3261 410.924C71.5886 410.662 71.7361 410.305 71.7361 409.934C71.7361 409.563 71.5886 409.207 71.3261 408.944C71.0635 408.682 70.7074 408.534 70.3361 408.534V408.478Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.394 321.216L86.59 402.416L84.266 404.152C84.266 404.152 57.582 383.264 57.582 365.862C57.582 348.46 62.23 321.79 62.23 321.79L65.394 321.216Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.394 321.216L62.23 321.762L84.266 404.124L86.59 402.388L65.394 321.216Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.954 236.558C92.9721 236.558 109.2 220.33 109.2 200.312C109.2 180.294 92.9721 164.066 72.954 164.066C52.9359 164.066 36.708 180.294 36.708 200.312C36.708 220.33 52.9359 236.558 72.954 236.558Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.298 227.703C99.4278 221.436 106.613 204.09 100.346 188.96C94.0786 173.831 76.7331 166.646 61.6034 172.913C46.4736 179.18 39.2889 196.525 45.5558 211.655C51.8228 226.785 69.1683 233.97 84.298 227.703Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7617 209.174L72.9537 200.312V227.766",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.6 156.8H145.6V273H250.6V156.8Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.272 163.8H151.928V266H244.272V163.8Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.974 191.8H177.226V238H218.974V191.8Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.4 446.6H659.54",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.844 546.966C361.844 546.966 433.244 553.168 450.38 550.06C467.516 546.952 434.854 531.426 465.92 529.872C496.986 528.318 540.47 545.412 566.888 545.412C593.306 545.412 576.198 522.102 587.076 515.886C597.954 509.67 652.316 515.886 660.086 515.886",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.894 525.168C369.894 525.168 407.022 526.904 431.186 525.168C455.35 523.432 391.482 513.968 425.152 508.774C458.822 503.58 476.952 514.808 508.886 519.134C540.82 523.46 527.016 516.544 532.196 503.594C537.376 490.644 634.914 507.906 659.092 507.906C683.27 507.906 666.862 509.628 656.502 499.268C646.142 488.908 681.534 494.088 681.534 494.088",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.178 530.782C570.178 533.4 562.828 535.528 553.77 535.528C544.712 535.528 537.376 533.4 537.376 530.782C537.376 528.164 544.712 526.036 553.77 526.036C562.828 526.036 570.178 528.164 570.178 530.782Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.6 520.422C460.6 522.564 456.736 524.314 451.962 524.314C447.188 524.314 443.338 522.564 443.338 520.422C443.338 518.28 447.202 516.544 451.962 516.544C456.722 516.544 460.6 518.28 460.6 520.422Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.464 540.708C429.464 541.66 427.14 542.43 424.284 542.43C421.428 542.43 419.104 541.66 419.104 540.708C419.104 539.756 421.4 539 424.284 539C427.168 539 429.464 539.756 429.464 540.708Z",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M640.15 186.2C640.15 186.2 642.88 169.862 625.632 162.596C608.384 155.33 600.208 166.222 595.658 177.128C591.108 188.034 591.122 180.754 575.694 181.664C560.266 182.574 564.802 197.064 558.446 202.538C552.09 208.012 538.468 196.182 531.202 202.538C526.556 206.731 522.576 211.608 519.4 217H670.11C670.11 217 674.646 204.288 665.574 197.022C656.502 189.756 641.06 201.6 640.15 186.2Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M506.8 270.634C506.8 270.634 509.124 256.634 494.34 250.39C479.556 244.146 472.542 253.498 468.65 262.85C464.758 272.202 464.758 265.958 451.528 266.742C438.298 267.526 442.176 279.972 436.73 284.648C431.284 289.324 419.608 279.188 413.378 284.648C409.39 288.257 405.977 292.454 403.256 297.094H532.476C532.476 297.094 536.382 286.202 528.584 279.972C520.786 273.742 507.514 283.864 506.8 270.634Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.076 120.274C548.547 116.517 558.854 100.118 555.096 83.6472C551.339 67.1759 534.941 56.8692 518.469 60.6265C501.998 64.3838 491.691 80.7823 495.449 97.2536C499.206 113.725 515.605 124.032 532.076 120.274Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28 129.22V150.64",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28 25.2V46.6199",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.98 87.9199H462.56",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 87.9199H566.58",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.076 117.124L480.928 132.272",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.632 43.5679L554.484 58.7159",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.58 87.9199H588",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.56 87.9199H483.98",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.484 117.124L569.632 132.272",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.928 43.5679L496.076 58.7159",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M350 43.3999V656.6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M446.6 189.182L463.876 176.582L440.538 128.982C440.538 128.982 439.138 118.72 448 121.52C456.862 124.32 476.938 148.582 486.276 157.92C495.614 167.258 499.338 172.844 497.938 177.52C496.538 182.196 452.676 217.644 452.676 217.644L446.6 189.182Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M246.106 505.946C246.106 505.946 209.37 529.844 196.98 539.14C187.454 546.105 177.033 551.756 165.998 555.94C161.14 557.704 149.632 555.94 146.524 559.482C143.416 563.024 142.548 572.306 142.548 576.73C142.548 581.154 136.794 602.854 134.582 611.254C132.37 619.654 138.558 622.762 141.218 622.762C143.878 622.762 143.878 616.126 146.972 611.702C150.066 607.278 165.172 579.838 177.506 573.636C189.84 567.434 246.554 547.526 263.368 539.112C280.182 530.698 286.384 522.746 286.384 522.746L246.106 505.946Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.424 415.436L259 487.032C259 487.032 251.398 488.306 250.138 490.196C248.878 492.086 241.906 504.77 241.906 504.77C241.906 504.77 256.466 518.77 272.314 525.686C282.232 529.973 292.665 532.952 303.352 534.548L338.8 448.378L270.424 415.436Z",
    fill: "#1B5FAD"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.988 505.4C300.958 502.236 306.628 506.674 312.788 511.84L318.514 497.91C307.16 490.42 290.71 480.2 284.2 484.148C275.338 489.468 278.292 498.33 270.62 503.65C264.936 507.584 256.368 497.322 249.41 491.456C247.198 495.208 241.948 504.77 241.948 504.77C249.204 511.493 257.187 517.386 265.748 522.34C267.456 516.74 267.036 508.914 280.112 511.336C292.81 513.688 287.112 523.138 286.426 530.768C291.996 532.442 297.681 533.706 303.436 534.548L309.19 520.548C302.946 513.464 291.032 508.578 295.988 505.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.938 481.236C271.53 481.866 281.988 450.058 292.446 460.516C302.904 470.974 310.1 495.67 322.378 488.404L330.442 468.804C329.466 468.236 328.408 467.821 327.306 467.572C317.268 465.22 302.498 456.946 313.726 453.404C319.844 451.472 328.244 453.054 334.908 457.954L338.856 448.35L296.59 428.008L290.08 432.124C290.08 432.124 294.28 446.894 282.408 451.038C275.184 453.558 269.276 450.576 264.978 449.638L259.938 481.236Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.548 421.778L322.378 488.404L333.97 463.008L266.896 417.928L268.548 421.778Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M270.424 415.436L259 487.032C259 487.032 251.398 488.306 250.138 490.196C248.878 492.086 241.906 504.77 241.906 504.77C241.906 504.77 256.466 518.77 272.314 525.686C282.232 529.973 292.665 532.952 303.352 534.548L338.8 448.378L270.424 415.436Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M127.498 558.18C127.498 558.18 128.38 598.892 129.262 610.848C130.144 622.804 138.124 628.544 140.77 627.648C143.416 626.752 143.878 623.658 141.218 622.776C138.558 621.894 131.922 617.022 131.922 605.976C131.922 594.93 134.134 560.826 134.134 558.18C134.134 555.534 129.262 555.968 127.498 558.18Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.252 579.866L162.89 589.204L153.468 603.442L132.37 596.68L133.252 579.866Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.97 391.538L189.91 376.152L223.076 408.184L207.746 424.914L204.694 421.148L216.678 407.288L189.91 381.304L175.616 395.024L172.97 391.538Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.354 531.09L67.606 440.23C66.2266 438.926 65.4209 437.127 65.3658 435.23C65.3107 433.332 66.0106 431.49 67.312 430.108L133.294 359.982C134.594 358.602 136.389 357.794 138.284 357.736C140.18 357.678 142.02 358.375 143.402 359.674L241.15 450.548C242.53 451.848 243.338 453.643 243.396 455.538C243.454 457.434 242.757 459.274 241.458 460.656L175.476 530.782C174.174 532.163 172.376 532.972 170.479 533.029C168.581 533.087 166.738 532.39 165.354 531.09Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.516 440.72L224.252 435.764L148.666 516.488L153.93 521.444L229.516 440.72Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5898 451.5L84.8538 456.456L160.454 375.718L155.19 370.762L79.5898 451.5Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M261.968 280.084C261.968 280.084 249.368 286.944 247.086 290.948C244.804 294.952 214.494 370.44 214.494 370.44C214.494 370.44 192.192 384.734 193.34 388.738C194.488 392.742 203.63 403.032 203.63 403.032H211.638C213.346 403.032 224.238 377.832 227.654 372.148C231.07 366.464 268.8 308.672 268.8 308.672L273.938 305.872L261.968 280.084Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M364 222.32C364 222.32 315.476 230.72 311.738 235.382C308 240.044 256.2 278.782 256.2 278.782L278.138 315.182L307.538 293.244C307.538 293.244 272.538 374.444 273 375.844C273.462 377.244 322.476 405.72 334.6 407.12C346.724 408.52 351.876 408.52 351.876 408.52C351.876 408.52 388.738 322.182 396.2 312.844C403.662 303.506 418.138 255.444 418.138 255.444L458.276 229.32L449.876 185.92L401.8 211.582L364 222.32Z",
    fill: "#1B5FAD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M394.198 288.498L406.238 226.8L400.218 222.292L381.654 217.308L364 222.32C364 222.32 357.602 223.426 349.286 225.05L394.198 288.498Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M307.538 293.244L332.262 277.004",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M319.312 285.334L335.034 283.486",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M418.138 255.444L423.22 232.582",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M418.054 254.1L428.806 233.016",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M432.796 163.8C432.796 163.8 436.926 180.768 437.85 183.064C438.774 185.36 442.4 189.504 442.4 193.2C442.4 196.896 435.526 199.612 435.526 199.612C435.526 199.612 434.602 221.172 431.396 223.93C428.19 226.688 404.334 221.13 404.334 221.13L398.832 238.098L391.034 272.048L359.842 223.888L369.026 209.202L360.766 182.14L430.934 158.34L432.796 163.8Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M404.362 221.144L399.07 218.708L398.86 238.112L404.362 221.144Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M417.2 176.176C417.2 176.176 418.348 186.396 426.58 189.238C434.812 192.08 436.226 182.994 435.946 179.872C435.666 176.75 434.812 171.64 434.812 171.64C428.586 170.968 422.327 172.58 417.2 176.176Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M417.256 176.176L391.146 184.408L392.28 185.836L418.404 180.726L417.256 176.176Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M434.868 171.64C434.868 171.64 436.856 168.84 439.404 172.494C441.952 176.148 439.124 183.848 439.124 183.848C439.124 183.848 435.148 176.176 434.868 171.64Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M419.818 199.738C420.753 201.034 421.938 202.13 423.304 202.959C424.67 203.789 426.189 204.336 427.77 204.568",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M426.818 159.712L360.794 182.112L369.054 209.174L368.788 209.594C371.084 210.182 374.822 210.798 377.538 209.678C381.738 207.928 390.838 200.578 390.838 200.578L392.238 185.794L399.238 190.428L400.988 189.378C402.738 188.328 402.388 179.928 402.388 179.928C402.388 179.928 403.438 179.228 409.038 174.678C413.196 171.332 422.38 163.52 426.818 159.712Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M395.654 190.876C395.654 190.876 389.69 177.114 382.802 184.45C375.914 191.786 388.766 203.252 390.6 203.714C392.039 203.871 393.49 203.552 394.73 202.804C395.383 206.726 397.135 210.381 399.784 213.346",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M395.654 190.876C395.654 190.876 389.69 177.114 382.802 184.45C375.914 191.786 388.766 203.252 390.6 203.714C392.039 203.871 393.49 203.552 394.73 202.804C395.383 206.726 397.135 210.381 399.784 213.346",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M335.692 227.892L358.498 392L362.936 381.85L343.924 225.988L335.692 227.892Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M364.196 379.316C364.196 379.316 352.8 402.766 352.8 404.67C352.8 406.574 368.648 414.176 371.812 413.532C374.976 412.888 381.318 395.794 382.592 388.822C383.866 381.85 369.264 376.152 364.196 379.316Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M487.34 578.97C487.34 578.97 494.634 578.074 491.442 587.58C488.598 596.349 482.655 603.781 474.726 608.482C467.306 612.878 444.864 623.756 436.814 624.708C428.764 625.66 426.72 618.842 434.014 612.906C441.308 606.97 474.838 588 477.4 585.48C479.962 582.96 487.34 578.97 487.34 578.97Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M379.4 463.596C383.508 483.042 390.974 501.622 401.464 518.504C423.962 554.162 431.76 597.016 434.686 609.504C435.038 611.024 435.74 612.442 436.735 613.644C437.73 614.846 438.991 615.801 440.419 616.431C441.846 617.061 443.401 617.35 444.96 617.276C446.519 617.201 448.039 616.764 449.4 616C449.835 615.764 450.256 615.502 450.66 615.216C457.94 610.26 467.11 605.164 467.11 605.164C467.11 605.164 482.874 594.524 485.17 591.164C487.466 587.804 490.112 571.116 489.888 567.966C489.664 564.816 483.518 567.77 481.124 569.856C478.436 571.792 475.578 573.478 472.584 574.896L448.938 581.658C448.938 581.658 437.64 534.212 435.526 522.942C428.806 487.242 420.616 440.706 414.918 435.638C409.22 430.57 399 428.106 399 428.106L379.4 463.596Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M456.204 579.418C456.204 579.418 456.834 601.356 461.496 612.626L478.548 604.072C478.548 604.072 475.244 582.918 475.118 581C474.613 578.549 473.896 576.146 472.976 573.818C472.976 573.818 461.734 575.54 456.204 579.418Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M355.74 184.45L360.038 154.392C360.354 152.197 361.29 150.138 362.736 148.456C364.182 146.775 366.077 145.541 368.2 144.9L408.968 132.622C411.575 131.845 414.369 131.976 416.892 132.993C419.415 134.01 421.518 135.854 422.856 138.222L435.092 159.726C435.092 159.726 488.754 144.13 485.086 149.184C481.418 154.238 409.864 171.584 379.134 181.748C348.404 191.912 321.804 208.81 319.97 206.948C318.136 205.086 355.74 184.45 355.74 184.45Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M451.276 124.32C451.276 124.32 441.476 116.382 433.538 117.782C425.6 119.182 395.738 122.444 392.938 124.32C390.138 126.196 381.738 138.782 381.738 138.782C381.738 138.782 381.738 139.72 384.076 139.72C386.414 139.72 394.8 130.382 394.8 130.382L397.6 129.92C397.6 129.92 387.338 138.32 389.2 140.644C391.062 142.968 396.676 138.32 398.076 137.382C399.476 136.444 406 132.72 406 132.72L416.276 131.32C416.276 131.32 406.476 139.244 404.138 141.582C401.8 143.92 402.276 146.72 406 144.382C409.724 142.044 420.476 135.044 420.476 135.044C420.476 135.044 427.476 132.72 429.8 131.782C432.124 130.844 436.8 128.52 436.8 128.52L443.8 132.244",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M451.276 124.32C451.276 124.32 441.476 116.382 433.538 117.782C425.6 119.182 395.738 122.444 392.938 124.32C390.138 126.196 381.738 138.782 381.738 138.782C381.738 138.782 381.738 139.72 384.076 139.72C386.414 139.72 394.8 130.382 394.8 130.382L397.6 129.92C397.6 129.92 387.338 138.32 389.2 140.644C391.062 142.968 396.676 138.32 398.076 137.382C399.476 136.444 406 132.72 406 132.72L416.276 131.32C416.276 131.32 406.476 139.244 404.138 141.582C401.8 143.92 402.276 146.72 406 144.382C409.724 142.044 420.476 135.044 420.476 135.044C420.476 135.044 427.476 132.72 429.8 131.782C432.124 130.844 436.8 128.52 436.8 128.52L443.8 132.244",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M397.6 129.92L406.868 126.588",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M274.862 372.4C274.862 372.4 260.862 404.068 263.452 414.848C266.042 425.628 367.36 491.512 367.36 491.512L406 428.106L352.8 404.67C352.8 404.67 296.408 393.26 274.862 372.4Z",
    fill: "#1B5FAD"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.8 404.67L351.918 404.474C352.132 405.814 352.132 407.18 351.918 408.52C350.98 412.062 323.806 406.154 327.936 416.794C332.066 427.434 358.736 422.702 363.986 429.786C369.236 436.87 354.536 454.02 341.586 448.112C328.636 442.204 316.176 425.068 313.824 438.06C312.872 443.268 314.58 450.562 317.016 457.562C322.924 461.664 328.818 465.682 334.362 469.448C328.762 461.44 325.486 454.86 331.562 456.386C345.744 459.928 355.782 480.018 364.056 476.476C372.33 472.934 358.148 448.112 367.598 441.014C377.048 433.916 387.1 443.968 390.642 434.518C394.184 425.068 377.048 425.068 368.788 417.97C365.694 415.324 364.91 412.608 365.386 410.172L352.8 404.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.2 419.16C280.094 420.38 276.22 422.272 272.734 424.76C278.054 429.282 285.334 434.826 293.356 440.762C292.975 439.166 292.964 437.504 293.323 435.902C293.682 434.301 294.402 432.803 295.428 431.522C303.702 421.47 319.662 429.744 323.204 418.516C326.746 407.288 304.29 404.936 309.022 393.12C309.19 392.7 309.358 392.308 309.54 391.93C302.411 389.243 295.486 386.043 288.82 382.354C285.11 384.258 279.244 388.752 286.566 396.074C296.59 406.154 297.178 415.604 284.2 419.16Z",
    fill: "white"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M274.862 372.4C274.862 372.4 260.862 404.068 263.452 414.848C266.042 425.628 367.36 491.512 367.36 491.512L406 428.106L352.8 404.67C352.8 404.67 296.408 393.26 274.862 372.4Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })));
};
export { SvgLeave1 as ReactComponent };
export default "/24a13dfd1130bcc6c7690abcaa268421.svg";